exports = module.exports = require("./../../../../../../.nvm/versions/node/v4.2.2/lib/node_modules/bb-lp-cli/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lp-content-item{position:relative}.lp-empty-content-item:after,.lp-over-content-item:after{content:'Replace ' attr(data-type);min-height:98px;text-shadow:1px 1px 0 #fff;display:block;padding:30px;text-align:center;border:1px solid #ddd;text-transform:uppercase;font-weight:700;color:#999;background:#f0f0f0;position:absolute;top:0;bottom:0;left:0;right:0}.lp-over-content-item:after{position:absolute;background-color:#ddd;color:#fff;opacity:.9;text-shadow:-1px -1px 0 rgba(0,0,0,.5)}.lp-empty-content-item:after{content:'Drop ' attr(data-type) ' here'}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** /Users/brenton/.nvm/versions/node/v4.2.2/lib/~/bb-lp-cli/~/css-loader!/Users/brenton/.nvm/versions/node/v4.2.2/lib/~/bb-lp-cli/~/less-loader!./styles/base.less
 ** module id = 2
 ** module chunks = 0
 **/